import { getScrollContainer } from '@/src/renderer/lib/dom/getScrollContainer'

const KEEP_SCROLL = 'data-keep-scroll'

/**
 * **⌘A lässt die Liste stehen** (#303, Runde 2). Alles auswählen legt den Fokus auf die letzte Zeile, und eine
 * fokussierte Zeile rollt sich sonst ins Bild (`TaskEntry`) — die Liste sprang ans Ende. Mit Lazy Rendering baute sie
 * dort dann auch alle Zeilen auf (gemessen 10.10.2026: ⌘A 115 ms). Der Griff selbst fokussiert schon mit
 * `preventScroll: true`; gemeint war also nie ein Sprung.
 *
 * Markiert den Scroller für die Fokus-Änderung dieses einen Drucks; danach gilt wieder das Übliche.
 */
export function keepScrollForThisFocus(listEl: Element | null): void {
  const container = getScrollContainer(listEl)
  if (!container) return
  container.setAttribute(KEEP_SCROLL, '')
  setTimeout(() => container.removeAttribute(KEEP_SCROLL), 150)
}

/** Soll die fokussierte Zeile gerade NICHT ins Bild rollen? */
export function keepsScroll(container: Element): boolean {
  return container.hasAttribute(KEEP_SCROLL)
}
